var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 16H17.5587C18.3547 16 19 15.3547 19 14.5587V14.5587C19 13.7433 18.5416 13.0063 17.8332 12.7047C17.0221 12.359 15.8195 12 14.3227 12C13.6534 12 13.043 12.0718 12.5 12.182M12 5.7C12 7.1913 13.343 9 15 9C16.657 9 18 7.1913 18 5.7C18 4.2087 16.657 3 15 3C13.343 3 12 4.2087 12 5.7ZM1 16.2406V16.2406C1 17.2123 1.7877 18 2.75938 18H10.2406C11.2123 18 12 17.2123 12 16.2406V16.2406C12 15.2869 11.5015 14.4141 10.7072 13.9963C9.78032 13.5088 8.36595 13 6.5 13C4.63405 13 3.21968 13.5088 2.29279 13.9963C1.49847 14.4141 1 15.2869 1 16.2406ZM10 5.66667C10 7.69167 8.43295 10 6.5 10C4.56705 10 3 7.69167 3 5.66667C3 3.64167 4.56705 2 6.5 2C8.43295 2 10 3.64167 10 5.66667Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.79f841354935a4e7450ed510ef44e3dd.svg";
export { ForwardRef as ReactComponent };